export const MINIMUM_DEPOSITS_TO_BE_SHOWN = 5;

